import { useContext } from 'react';
import { InfoOutlined } from '@mui/icons-material';

import { Report } from '../../interfaces';
import ActionItem from '../utils/tableActionTrigger';
import { HandleOpenDetailsDialog } from '../interfaces';
import { LocalesContext } from '../../localesContext';

interface Props {
  item: Report;
  handleOpenDetailsDialog: HandleOpenDetailsDialog;
}

const DetailsAction = ({ item, handleOpenDetailsDialog }: Props) => {
  const locales = useContext(LocalesContext);

  return (
    <ActionItem onClick={() => handleOpenDetailsDialog(item)} item={item} tooltip={locales.tooltip.details}>
      <InfoOutlined cursor="pointer" data-testid="details" />
    </ActionItem>
  );
};

export default DetailsAction;
